// extracted by mini-css-extract-plugin
export var backgroundCoverCenter = "layout-module--background-cover-center--25p8z";
export var backgroundCoverTop = "layout-module--background-cover-top--3v_Bb";
export var backgroundContainTop = "layout-module--background-contain-top--2Kt8w";
export var backgroundContainCenter = "layout-module--background-contain-center--3Zioy";
export var backgroundContainLeft = "layout-module--background-contain-left--2aQ2a";
export var layout = "layout-module--layout--3bcI5";
export var cover = "layout-module--cover--1nCnp";
export var formContainer = "layout-module--form-container--1CeLR";
export var disabled = "layout-module--disabled--1tmle";